import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-navy" data-id="element-83" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-4 sm:px-5" data-id="element-84" data-mp="9u38a33nue6g">
        <Reveal className="flex items-start gap-3 rounded-2xl border-2 border-navy bg-cielo p-3 text-left" data-id="element-85" data-mp="9wpenzetenn3">
          <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border-2 border-sol bg-navy" data-id="element-86" data-mp="jsitxqjx4v8k">
            <ShieldCheckIcon size={24} className="text-sol" data-id="element-87" data-mp="ntcec9y5jrwp" />
          </span>
          <div data-id="element-88" data-mp="sl49yyw60ntp">
            <p className="font-sub text-xs font-semibold uppercase tracking-wide text-navy/80" data-id="element-89" data-mp="skkq3cmyfpd1">
              Tu inversión está protegida
            </p>
            <h2 id="garantia" className="font-display text-xl font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-90" data-mp="xm1qz85fvbtm">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-xs leading-snug text-navy/80 sm:text-sm" data-id="element-91" data-mp="25rnkn44bquve">
              Tenés 7 días para explorar los 6 tomos y los 5 bonos. Si
              considerás que el sistema no es adecuado para vos, podés
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}